import { Card, FloatButton, Pagination, Space } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'
import MobileAbonements from './MobileAbonements'
import { useState } from 'react'
import MobileAbonementsCost from './MobileAbonementsCost'
import { LeftOutlined } from '@ant-design/icons';
import MobileAbonementsSostav from './MobileAbonementsSostav'
import MobileAbonementsServices from './MobileAbonementsServices'

const MobileAbonementsPage = ({
    abonementInfo,
    setAbonementInfo,
    abonementCostInfo,
    setAbonementCostInfo,
    abonementSostavInfo,
    setAbonementSostavInfo,
    abonementServiceInfo,
    setAbonementServiceInfo,
    mnemo
}) => {

    const abonementsList = useSelector(state => state.AbonementsSlice.abonementsList)
    const abonementsListLoading = useSelector(state => state.AbonementsSlice.abonementsListLoading)

    const abonementsClubsList = useSelector(state => state.AbonementsSlice.abonementsClubsList)
    const abonementsClubsListLoading = useSelector(state => state.AbonementsSlice.abonementsClubsListLoading)

    const abonementClubsItems = useSelector(state => state.AbonementsSlice.abonementClubsItems)
    const abonementClubsItemsLoading = useSelector(state => state.AbonementsSlice.abonementClubsItemsLoading)

    const abonementListClubServices = useSelector(state => state.AbonementsSlice.abonementListClubServices)
    const abonementListClubServicesLoading = useSelector(state => state.AbonementsSlice.abonementListClubServicesLoading)

    const [tab, setTab] = useState('Абонементы')
    const [page, setPage] = useState(1)

    return (
        <Space style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} direction="vertical">

            <Pagination
                defaultCurrent={page}
                pageSize={20}
                showSizeChanger={false}
                current={page}
                onChange={(page, pageSize) => {
                    setPage(page)
                }}
                total={abonementsList?.value?.data?.totalCount}
                page={page}
            />

            {tab === 'Абонементы' && <MobileAbonements
                abonementsList={abonementsList}
                abonementsListLoading={abonementsListLoading}
                setTab={setTab}
                abonementInfo={abonementInfo}
                setAbonementInfo={setAbonementInfo}
                mnemo={mnemo}
            />}
            {tab === 'Стоимость пакета' && <MobileAbonementsCost
                abonementsClubsList={abonementsClubsList}
                abonementsClubsListLoading={abonementsClubsListLoading}
                abonementInfo={abonementInfo}
                abonementCostInfo={abonementCostInfo}
                setAbonementCostInfo={setAbonementCostInfo}
                mnemo={mnemo}
                setTab={setTab}
            />}
            {tab === 'Состав пакета' && <MobileAbonementsSostav
                abonementClubsItems={abonementClubsItems}
                abonementClubsItemsLoading={abonementClubsItemsLoading}
                setTab={setTab}
                abonementCostInfo={abonementCostInfo}
                abonementSostavInfo={abonementSostavInfo}
                setAbonementSostavInfo={setAbonementSostavInfo}
                mnemo={mnemo}
            />}
            {tab === 'Услуги' && <MobileAbonementsServices
                abonementListClubServices={abonementListClubServices}
                abonementListClubServicesLoading={abonementListClubServicesLoading}
                abonementCostInfo={abonementCostInfo}
                abonementServiceInfo={abonementServiceInfo}
                setAbonementServiceInfo={setAbonementServiceInfo}
                setTab={setTab}
                mnemo={mnemo}
            />}
            {(tab === 'Стоимость пакета' || tab === 'Состав пакета' || tab === 'Услуги') &&
                <FloatButton
                    style={{ left: 24 }}
                    type="primary"
                    icon={<LeftOutlined />}
                    onClick={() => {
                        if (tab === 'Стоимость пакета') {
                            setTab('Абонементы')
                        } else if (tab === 'Состав пакета') {
                            setTab('Стоимость пакета')
                        }
                        else if (tab === 'Услуги') {
                            setTab('Стоимость пакета')
                        }
                    }}
                />}
        </Space>
    )
}

export default MobileAbonementsPage